/**
 * @description 外部リンクを別タブ開き,主にcms表示用
 */

export const setExternalLink = () => {
  const target = $('.js-external');
  if (!target.length) return;
  target.not('[href*="' + location.hostname + '"]').attr({ target: '_blank' });
};
